import type { components } from "@majitap/sdk";
import type { NavSection } from "@majitap/ui";
import { type QueryClient, queryOptions } from "@tanstack/react-query";
import { api, ok } from "./api";

export type Counts = components["schemas"]["Counts"];

/**
 * What needs the signed-in person now (`GET /v1/admin/counts`): only the keys their permissions
 * allow. Today by default; the dispatch board asks for its own day.
 */
export const countsQuery = (date?: string) =>
  queryOptions({
    queryKey: ["counts", date ?? "today"],
    refetchInterval: 60_000,
    staleTime: 15_000,
    queryFn: () => ok(api.GET("/v1/admin/counts", { params: { query: { date } } })),
  });

/** The menu items that carry a badge, and what each counts. */
export function navCounts(counts: Counts | undefined): Record<string, number | undefined> {
  return {
    dispatch: counts?.dispatch?.unassigned,
    incidents: counts?.incidents?.open,
    payouts: counts?.payouts?.to_approve,
  };
}

/** The menu with each badge filled in; a zero shows no badge. */
export const withCounts = (sections: NavSection[], counts: Counts | undefined): NavSection[] => {
  const byItem = navCounts(counts);
  return sections.map((s) => ({ ...s, items: s.items.map((item) => ({ ...item, count: byItem[item.id] })) }));
};

/** After anything that changes what's waiting (a delivery planned, an incident resolved, a payout reviewed). */
export const refreshCounts = (queryClient: QueryClient) => queryClient.invalidateQueries({ queryKey: ["counts"] });
